(function(){
  'use strict'; 

  theme.VimeoPlayer = (function() {
    var defaults = {
      byline: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false
    };

    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    };
  
    function VimeoPlayer(divId, videoId, options) {
      this.divId = divId;
      this.el = document.getElementById(divId);
      this.videoId = videoId;
      this.iframe = null;
      this.options = options || {};
  
      this.parent = this.options.productMediaWrapper ? this.el.closest(this.options.productMediaWrapper) : null;
  
      this.setAsLoading();
  
      if (theme.config.vimeoReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
        document.addEventListener('vimeoReady', this.init.bind(this));
      }
    }
  
    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function() {
        var playerOptions = Object.assign({}, defaults, { id: this.videoId });
        this._createPlayer(playerOptions);
      },
  
      _createPlayer: function(options) {
        this.videoPlayer = new Vimeo.Player(this.el, options);
        this._onPlayerReady();
      },
  
      _onPlayerReady: function() {
        this.videoPlayer.ready().then(function() {
          this.iframe = this.el.querySelector('iframe');
          this.iframe.setAttribute('tabindex', '-1');
  
          if (this.options.loop === 'false') {
            this.videoPlayer.setLoop(false);
          }
  
          this.videoPlayer.setVolume(this.options.style === 'sound' ? 1 : 0);
  
          this.setAsLoaded();
          this._setupObserver();
        }.bind(this));
      },
  
      _setupObserver: function() {
        var observer = new IntersectionObserver(
          function(entries) {
            entries.forEach(
              function(entry) {
                if (entry.isIntersecting) {
                  this.play();
                } else {
                  this.pause();
                }
              }.bind(this)
            );
          }.bind(this),
          { rootMargin: '0px 0px 50px 0px' }
        );
  
        observer.observe(this.iframe);
      },
  
      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },
  
      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded, classes.interactable);
  
        if (Shopify && Shopify.designMode && window.AOS) {
          AOS.refreshHard();
        }
      },
  
      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },
  
      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play();
        }
      },
  
      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause();
        }
      },
  
      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });
  
    return VimeoPlayer;
  })();

  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  }

  window.vimeoApiReady = function() {
    theme.config.vimeoLoading = true;

    checkIfVimeoIsReady()
      .then(function() {
        theme.config.vimeoReady = true;
        theme.config.vimeoLoading = false;
        document.dispatchEvent(new CustomEvent('vimeoReady'));
      });
  }
  
  function checkIfVimeoIsReady() {
    var wait;
    var timeout;
  
    var deferred = new Promise((resolve, reject) => {
      wait = setInterval(function() {
        if (!Vimeo) {
          return;
        }
  
        clearInterval(wait);
        clearTimeout(timeout);
        resolve();
      }, 500);
  
      timeout = setTimeout(function() {
        clearInterval(wait);
        reject();
      }, 4000); // subjective. test up to 8 times over 4 seconds
    });
  
    return deferred;
  }
  /**
   * YouTube SDK method
   * -----------------------------------------------------------------------------
   * Parameters:
   * - player div id (required)
   * - arguments
   * - videoId (required)
   * - productMediaWrapper (selector, optional for section loading state)
   * - events (object, optional)
   */
  theme.YouTube = (function() {
    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 1,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        start: 0,
        rel: 0
      },
      events: {
        onReady: "onPlayerReady",
        onStateChange: "onPlayerChange"
      }
    };

    var classes = {
      playing: 'video-is-playing',
      paused: 'video-is-paused',
      loading: 'loading',
      loaded: 'loaded',
      backgroundVideoWrapper: 'video-background-wrapper',
      videoWithImage: 'video--image_with_play',
      backgroundVideo: 'video--background',
      userPaused: 'is-paused',
      supportsAutoplay: 'autoplay',
      supportsNoAutoplay: 'no-autoplay',
      wrapperMinHeight: 'video-section-wrapper--min-height',
      interactable: 'video-interactable'
    };
  
    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;
      this.attemptedToPlay = false;
  
      this.options = Object.assign({}, defaults, options);
      this.options.events = {
        onReady: this._onPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this)
      };
  
      if (this.options.productMediaWrapper) {
        this.parent = document.getElementById(this.divId).closest(this.options.productMediaWrapper);
      } else {
        this.parent = null;
      }
  
      if (!this.options.autoplay) {
        this.options.playerVars.autoplay = this.options.autoplay;
      }
  
      if (this.options.style === 'sound') {
        this.options.playerVars.controls = 1;
        this.options.playerVars.autoplay = 0;
      }
  
      this.setAsLoading();
  
      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }
  
    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function() {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },
  
      _onPlayerReady: function(evt) {
        this.iframe = document.getElementById(this.divId);
        this.iframe.setAttribute('tabindex', '-1');
  
        if (this.options.style !== 'sound') {
          evt.target.mute();
        }
  
        this._observeVideoVisibility();
      },
  
      _observeVideoVisibility: function() {
        var observer = new IntersectionObserver(
          function(entries) {
            entries.forEach(
              function(entry) {
                if (entry.isIntersecting) {
                  this.play();
                } else {
                  this.pause();
                }
              }.bind(this)
            );
          }.bind(this),
          { rootMargin: '0px 0px 50px 0px' }
        );
  
        observer.observe(this.iframe);
      },
  
      onVideoStateChange: function(evt) {
        switch (evt.data) {
          case -1: // unstarted
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },
  
      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },
  
      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
  
        if (Shopify && Shopify.designMode && window.AOS) {
          AOS.refreshHard();
        }
      },
  
      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },
  
      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },
  
      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },
  
      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });
  
    return YouTube;
  })();

  theme.Video = (function() {
    var selectors = {
      productMediaWrapper: '[data-product-single-media-wrapper]'
    };

    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-block-id') ? container.getAttribute('data-block-id') : container.getAttribute('data-section-id')

      this.namespace = '.video-' + this.sectionId;
      this.videoObject = null

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500
      });

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', function(event) {
          this.init()
        }.bind(this));
      }
    }

    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function() {
        var dataDiv = this.container.querySelector('.video-div');
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;

        switch(type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case 'mp4':
            this.initMp4Video();
            break;
        }
      },

      initYoutubeVideo: function(videoId) {
        this.videoObject = new theme.YouTube(
          'YouTubeVideo-' + this.sectionId,
          {
            videoId: videoId,
            productMediaWrapper: selectors.productMediaWrapper
          }
        );
      },

      initVimeoVideo: function(videoId) {
        this.videoObject = new theme.VimeoPlayer(
          'Vimeo-' + this.sectionId,
          videoId,
          {
            productMediaWrapper: selectors.productMediaWrapper
          }
        );
      },

      initMp4Video: function() {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.productMediaWrapper);

        if (mp4Div) {
          parent.classList.add('loaded');

          var playPromise = document.querySelector('#' + mp4Video).play();

          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise.then(function() {
              // playback normal
            }).catch(function() {
              mp4Div.setAttribute('controls', '');
              parent.classList.add('video-interactable');
            });
          }
        }
      },

      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        if (this.videoObject && typeof this.videoObject.destroy === 'function') {
          this.videoObject.destroy();
        }
      }
    });

    return videoSection;
  })();

  theme.Audio = (function() {
    var selectors = {
      productMedia: '[data-product-single-audio]',
      productListing: '[data-audio-thumbs]',
      productListingItem: ".column-grid__item",
      productBtn: '.product__btn',
      percentage: '.countdown_slider',
      sliderContainer: '.countdown_slider--container',
      currentTime: '.countdown_timer'
    };

    function audioSection(container) {
      this.container = container;
      this.listingContainer = this.container.querySelector(selectors.productListing)

      this.media = this.container.querySelector(selectors.productMedia)
      this.isMediaLoaded = false

      if (this.listingContainer) {
        this._onPlayerReady()
      } 
      
      if (this.media) {
        this.media.onloadeddata = function(evt) {
          if (this.isMediaLoaded) return
          this.isMediaLoaded = true

          this.init(evt.target)
        }.bind(this);

        window.addEventListener('load', function (evt) {              
          setTimeout(function(){
            if (this.isMediaLoaded) return
            this.isMediaLoaded = true
            this.init(this.media)            
          }.bind(this), 2000);
        }.bind(this))        
      }     
    }

    audioSection.prototype = Object.assign({}, audioSection.prototype, {
      init: function(item) {
        this.isMediaLoaded = true
        this.playBtn = this.container.querySelector(selectors.productBtn)
        
        this.playBtn.addEventListener('click', function() {
          this.togglePlay()
        }.bind(this));
        
        this.container.querySelector(selectors.productMedia).addEventListener('timeupdate', function() {
          this.initMp3Audio()
        }.bind(this));
        
        this.playBtn.classList.remove("btn--loading","btn--disabled")
        this.playBtn.classList.add("btn--play")

        this.container.querySelector(selectors.currentTime).innerHTML = this.calculateCurrentValue(this.media.currentTime, this.media.duration);

        var itemTitle = this.container.querySelector(".product__title")
        if (itemTitle && itemTitle.innerHTML == "") {
          
          var dataURL = item.src

          var filename = this._getFilename(dataURL)

          itemTitle.innerHTML = filename
        }
      },

      _onPlayerReady: function() {
        this.playerTitle = this.container.querySelector(".product__title p")

        this.listingContainer.querySelectorAll(selectors.productListingItem).forEach((item, index) => {
          var dataURL = item.dataset.src

          var filename = this._getFilename(dataURL)

          var itemTitle = item.querySelector(".column-grid__item--title")
          itemTitle.innerHTML = filename

          if (index == 0) {
            item.classList.add("is-active")
            this.playerTitle.innerHTML = filename
            this.selectedItem = item
          }

          itemTitle.addEventListener('click', function(el) {
            var closestParent = el.target.parentNode.closest('div');

            this.playerTitle.innerHTML = this._getFilename(closestParent.dataset.src)
            this.setMP3Player(closestParent)
          }.bind(this));
        });
      },

      initMp3Audio: function() {
        const currentTime = this.calculateCurrentValue(this.media.currentTime, this.media.duration);

        this.container.querySelector(selectors.currentTime).innerHTML = currentTime;

        this.sliderContainer = this.container.querySelector(selectors.sliderContainer)
        this.sliderContainer.addEventListener('click', function(evt) {
          this.seek(evt)
        }.bind(this));
      
        this.media.onended = () => {
          this.playBtn.classList.remove('playing');
          this.container.querySelector(selectors.percentage).style.width = 0;
          this.container.querySelector(selectors.currentTime).innerHTML = '00:00';
        };

        this.calculatePercentPlayed();
      },

      togglePlay: function() {
        var activeMedia = document.querySelector(selectors.productMedia+".playing")

        if (activeMedia && activeMedia != this.media) {          
          this.pause(activeMedia, activeMedia.parentElement.querySelector(selectors.productBtn))
        }
        
        if (this.media.paused === false) {
          this.pause(this.media, this.playBtn)
        } else {
          this.play(this.media, this.playBtn)
        }
      },

      play: function(media, playBtn) {
        media.play();          
        media.classList.add('playing');
        playBtn.classList.add('playing');
      },

      pause: function(media, playBtn) {
        media.pause();          
        media.classList.remove('playing');
        playBtn.classList.remove('playing');
      },

      calculatePercentPlayed: function() {
        let percentage = (this.media.currentTime / this.media.duration).toFixed(2) * 100;
        this.container.querySelector(selectors.percentage).style.width = `${percentage}%`;
      },
      
      calculateCurrentValue: function(currentTime, duration) {
        if (isNaN(duration) == true) {
          return "00:00"
        }

        var currentTime = duration - currentTime
        const currentMinute = parseInt(currentTime / 60) % 60;
        const currentSecondsLong = currentTime % 60;
        const currentSeconds = currentSecondsLong.toFixed();
        const currentTimeFormatted = `${currentMinute < 10 ? `0${currentMinute}` : currentMinute}:${
        currentSeconds < 10 ? `0${currentSeconds}` : currentSeconds
        }`;

        return currentTimeFormatted;
      },

      seek: function(e) {
        const percent = e.offsetX / this.sliderContainer.offsetWidth;
        this.media.currentTime = percent * this.media.duration;
      },

      setMP3Player: function(item) {
        if (this.media.src == item.dataset.src) {
          /*if (this.media.paused === false) {
            this.pause(this.media, this.playBtn)
          } else {
            this.play(this.media, this.playBtn)
          }*/
          this.togglePlay()
          return
        } 
        this.selectedItem.classList.remove("is-active")
        item.classList.add("is-active")
        this.selectedItem = item

        this.pause(this.media, this.playBtn)
        
        this.media.src = item.dataset.src

        this.isListedMediaLoaded = false
        this.playBtn.classList.add("btn--loading","btn--disabled")
        this.media.load(); //call this to just preload the audio without playing
        this.media.onloadeddata = function() {
          if (this.isListedMediaLoaded) return
          this.isListedMediaLoaded = true

          this.playBtn.classList.remove("btn--loading","btn--disabled")
          this.play(this.media, this.playBtn)
        }.bind(this);

        window.addEventListener('load', function () {              
          setTimeout(function(){
            if (this.isListedMediaLoaded) return
            this.isListedMediaLoaded = true

            this.playBtn.classList.remove("btn--loading","btn--disabled")
            this.play(this.media, this.playBtn)         
          }.bind(this), 2000);
        }.bind(this))
         //call this to play the song right away
      },
      
      _getFilename: function(url) {
        let filename = '';
        try {
          filename = new URL(url).pathname.split('/').pop();
        } catch (e) {
          console.error(e);
        }

        return (`${filename}`).replaceAll('_', ' ').replace('.mp3', '')
      }
    });

    return audioSection;
  })();

  function DOMCollectionready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  DOMCollectionready(function(){
    theme.sections.register('video', theme.Video);
    theme.sections.register('audio', theme.Audio);
  });
})();